module.exports = __webpack_public_path__ + "img/finance.6602f4b9.jpg";